module.exports = __webpack_public_path__ + "img/es_flag.caa6452f.svg";